import { fetchApi } from './api';

// Fetch all category types
export const getCategoryTypes = async () => {
  return fetchApi('/category-types', { method: 'GET' });
};

// Create new category
export const createCategory = async (categoryData) => {
  return fetchApi('/category-types', {
    method: 'POST',
    body: categoryData,
  });
};

// Update existing category
export const updateCategory = async (id, categoryData) => {
  return fetchApi(`/category-types/${id}`, {
    method: 'PUT',
    body: categoryData,
  });
};
